import React from 'react';
import { Box, Text, Flex, Icon } from '@chakra-ui/react';
import { MdClose } from 'react-icons/md';

const ErrorIntent = ({ error }) => {
  return (
    <Box
      m="0 auto"
      borderRadius={8}
      p={{ base: '10px', md: '30px 20px 60px' }}
      bg="#fff"
      mt="30px"
      justifyContent="center"
    >
      <Flex alignItems="center" justifyContent="center" flexDirection="column">
        <Flex
          bg="#f6f6f6"
          p="8px 7px 7px 8px"
          w="90px"
          h="90px"
          borderRadius="50%"
          justifyContent="center"
          textAlign="center"
        >
          <Icon as={MdClose} fontSize="55px" color="red" alignSelf="center" />
        </Flex>
        <Text fontSize="16px" fontWeight="bold" mt="20px" mb="50px" px="10px" textAlign="center">
          {error}
        </Text>
      </Flex>
    </Box>
  );
};

export default ErrorIntent;
